module.exports = __webpack_public_path__ + "static/seo-converthero-95fa204c13da00f0bea076960e8414c6.png";